// Estrutura do questionário de anamnese. O modelo padrão vive no código (padrao.ts) e cada anamnese
// guarda o código e a versão do modelo que o paciente viu — mudar uma pergunta é versão nova.

export const ALERTAS_DA_ANAMNESE = [
  "ALERGIA",
  "ANTICOAGULANTE",
  "COAGULACAO",
  "CARDIOPATIA",
  "HIPERTENSAO",
  "DIABETES",
  "GESTANTE",
  "BIFOSFONATO",
  "IMUNOSSUPRESSAO",
] as const;
export type AlertaDaAnamnese = (typeof ALERTAS_DA_ANAMNESE)[number];

export const ROTULO_DO_ALERTA: Record<AlertaDaAnamnese, string> = {
  ALERGIA: "Alergia",
  ANTICOAGULANTE: "Anticoagulante",
  COAGULACAO: "Coagulação",
  CARDIOPATIA: "Cardiopatia",
  HIPERTENSAO: "Hipertensão",
  DIABETES: "Diabetes",
  GESTANTE: "Gestante ou lactante",
  BIFOSFONATO: "Bifosfonato",
  IMUNOSSUPRESSAO: "Imunossupressão",
};

export type TipoDePergunta = "SIM_NAO" | "TEXTO" | "ESCOLHA" | "MULTIPLA" | "ESCALA";

export type Pergunta = {
  id: string;
  texto: string;
  tipo: TipoDePergunta;
  ajuda?: string;
  /** Sem resposta, a anamnese não pode ser enviada. Vazio nunca vale como "Não". */
  obrigatoria?: boolean;
  opcoes?: { valor: string; rotulo: string }[];
  /** SIM_NAO: campo de detalhe que aparece no "Sim". */
  detalhe?: { rotulo: string; obrigatorio?: boolean };
  /** Gera o alerta quando a resposta (ou uma das marcadas) está em `quando`. */
  alerta?: { codigo: AlertaDaAnamnese; quando: string[] };
  /** Só aparece quando outra pergunta tem um destes valores. */
  mostrarSe?: { pergunta: string; valores: string[] };
};

export type SecaoDaAnamnese = { id: string; titulo: string; descricao?: string; perguntas: Pergunta[] };

export type ModeloDeAnamnese = {
  codigo: string;
  versao: number;
  /** Perguntas ainda não validadas por cirurgião-dentista. */
  rascunhoClinico: boolean;
  secoes: SecaoDaAnamnese[];
};

export const SIM_NAO = [
  { valor: "SIM", rotulo: "Sim" },
  { valor: "NAO", rotulo: "Não" },
  { valor: "NAO_SEI", rotulo: "Não sei" },
];
